import { useRef } from 'react';
import type React from 'react';

/**
 * Props for a modal's backdrop that close it on a click outside the card.
 *
 * Only a press that both starts and ends on the backdrop counts. A plain
 * onClick check (e.target === e.currentTarget) also fires when a drag starts
 * inside the card, e.g. selecting text, and is released over the backdrop,
 * since the browser sends that click to the elements' common ancestor.
 *
 * Usage: <div className="crewcast-modal-overlay" {...useBackdropDismiss(onClose, locked)}>
 */
export function useBackdropDismiss(onClose: () => void, disabled = false) {
  const pressStartedOnBackdrop = useRef(false);

  return {
    onMouseDown: (e: React.MouseEvent<HTMLElement>) => {
      pressStartedOnBackdrop.current = e.target === e.currentTarget;
    },
    onClick: (e: React.MouseEvent<HTMLElement>) => {
      const startedHere = pressStartedOnBackdrop.current;
      pressStartedOnBackdrop.current = false;
      if (!disabled && startedHere && e.target === e.currentTarget) onClose();
    },
  };
}
